<template>
    <Background
        :backPath="'/home'">

        <div class="add-qrcode-area">
            <div class="add-qrcode-title">
                批量录入主控序列号（一次只能输入10个）
            </div>
            <a-textarea
                v-model="info"
                :rows="15"/>
            <div class="submit-button-area">
                <a-button
                    v-on:click="printQrCode"
                    class="submit-button"
                    size="large"
                    type="primary">
                    生成二维码图片
                </a-button>
            </div>

        </div>
    </Background>
</template>

<script>
 import Vue from 'vue';
 import Background from "./Background.vue"
 import ListView from "./ListView.vue"
 import InputSearch from "ant-design-vue/lib/input/Search";

 import { isEmptyOrWhitespace } from "../util/utils.js"
 import { parseDate } from "../util/date.js"

 Vue.component(InputSearch.name, InputSearch);

 export default {
     name: 'PrintBoxQrCode',
     data() {
         return {
             info: "",
         }
     },
     components: {
         Background,
     },
     computed: {
     },
     mounted() {
     },
     methods: {
         printQrCode() {
             var lines = this.info.split("\n")

             sessionStorage.setItem("renderBoxQRCodeInfo", JSON.stringify(lines.filter((e) => {
                 return e != ""
             })))
             this.$router.push("/renderBoxQRCode")

             this.info = ""
         }
     },
 }
</script>

<style scoped>
 .search {
     width: 400px;
 }

 .search-hint-area {
     height: 50px;
 }

 .search-content {
     padding-top: 2px;
     padding-right: 2px;
     padding-left: 5px;
     padding-right: 5px;
     color: #666;
     font-size: 16px;
     margin-top: 10px;
     margin-bottom: 10px;
 }

 .search-hint {
     display: flex;
     flex-direction: row;
     align-items: center;
     justify-content: center;
 }

 .clean-search {
     background-color: #F9D878;
     color: #666;
     font-size: 16px;
     border-radius: 5px;
     padding-top: 2px;
     padding-right: 2px;
     padding-left: 5px;
     padding-right: 5px;
     cursor: pointer;
 }

 .merchant-amount {
     width: 100%;
     margin-top: 10px;
     color: #999;
 }

 .add-qrcode-area {
     padding: 30px;
     background-color: #FFF;
     border-radius: 5px;
     width: 650px;
     height: 550px;
     position: absolute;
     display: flex;
     flex-direction: column;
     align-items: center;
 }
 .submit-button-area {
     position: absolute;
     bottom: 30px;
     display: flex;
     flex-direction: row;
     align-items: center;
 }
 .submit-button {
     width: 150px;
     margin-left: 10px;
     margin-right: 10px;
 }

 .add-qrcode-title {
     font-size: 24px;
     margin-bottom: 40px;
 }
</style>
